module.exports = __webpack_public_path__ + "static/img/jp0.51c538d5.png";